import PackageService from '../common/services/package/package.service';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';
import { TbasService } from './services/tbas.services';
import NoAuthService from '../no-auth/services/noauth.service';

export default function($stateProvider) {
  'ngInject';

  $stateProvider.state('buy', {
    component: 'fizyPaycellBuy',
    parent: 'mainWrapper',
    resolve: {
      packet: [
        '$state',
        '$stateParams',
        '$q',
        'packageService',
        'globalSpinner',
        'noAuthService',
        (
          $state,
          $stateParams,
          $q,
          packageService: PackageService,
          globalSpinner: GlobalSpinnerService,
          noAuthService: NoAuthService
        ) => {
          if (!$stateParams.packetId) {
            return $q.reject('Package not found');
          }

          globalSpinner.start();

          if (['premium', 'student', 'family', 'duo'].indexOf($stateParams.packetId.toLowerCase()) > -1) {
            return noAuthService.getOfferIdFromType($stateParams.packetId)
              .then(offerId => {
                if (offerId) {
                  $state.go('buy', { packetId: offerId });
                } else {
                  $state.go('myAccount');
                }
              })
              .catch(() => $state.go('myAccount'))
              .finally(() => globalSpinner.stop());
          }

          return packageService
            .getUserOfferablePackages()
            .then(packages => {             
              for (var i = 0; i < packages.length; i++) {
                if (packages[i].id === $stateParams.packetId) {
                  return $q.resolve(packages[i]);
                }
              }
              $state.go('myAccount');
            })
            .catch(() => $q.reject('Package not found'))
            .finally(() => globalSpinner.stop());
        }
      ],
      invoice: [
        '$q',
        'tbasService',
        'globalSpinner',
        ($q, tbasService: TbasService, globalSpinner: GlobalSpinnerService) => {
          globalSpinner.start();
          return tbasService
            .getInvoiceAddressInfo()
            .catch((/*error*/) => $q.resolve())
            .finally(() => globalSpinner.stop());
        }
      ]
    },
    url: '/buy/:packetId?promocode'
  });
}



// WEBPACK FOOTER //
// ./src/app/buy/buy.routes.ts